import request from 'sb-request'
import { constants, mixpanel } from 'common/helpers'

import subscriptionProcessing from './subscriptionProcessing'


type CommitValues = {
  token?: string
  giftCardSession?: string
  redeemCouponSession?: string
  subscriptionSession?: string
  giftSubscriptionSession?: string
}

type SetupCommitValues = {
  endpoint: string
  tokenName: string
  withErrorModal?: boolean
  withProgressRequest?: boolean
}

const setupCommit = ({ endpoint, tokenName, withProgressRequest, withErrorModal = true }: SetupCommitValues) => (
  (values: CommitValues = {}) => {
    const params = {
      body: values,
      tokenName,
      withErrorModal,
    }

    mixpanel.track(constants.analyticsEvents.tech.commitStart)

    return request.post(endpoint, params)
      .then(
        (result) => {
          mixpanel.track(constants.analyticsEvents.tech.commitSuccess)

          return result
        },
        ({ error, message, title, statusCode, resData }) => {
          mixpanel.track(constants.analyticsEvents.tech.commitError)

          const isStartSubscriptionProcessing = (
            withProgressRequest && values.subscriptionSession && (error === 'timeout' || statusCode === 504)
          )

          return isStartSubscriptionProcessing
            ? subscriptionProcessing({ subscriptionSession: values.subscriptionSession })
            : Promise.reject({ error, message, title, statusCode, resData })
        }
      )
  }
)


export default setupCommit
